var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_980_1144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7781 18.3333V3.16663C12.7781 2.3382 13.4497 1.66663 14.2781 1.66663H16.8337C17.6621 1.66663 18.3337 2.3382 18.3337 3.16662V16.8333C18.3337 17.6617 17.6621 18.3333 16.8337 18.3333H12.7781ZM12.7781 18.3333H7.22255M12.7781 18.3333V7.79625C12.7781 6.96783 12.1065 6.29626 11.2781 6.29626H8.72255C7.89412 6.29626 7.22255 6.96783 7.22255 7.79626V18.3333M7.22255 18.3333H3.16699C2.33856 18.3333 1.66699 17.6617 1.66699 16.8333V12.4259C1.66699 11.5975 2.33856 10.9259 3.16699 10.9259H5.72255C6.55097 10.9259 7.22255 11.5975 7.22255 12.4259V18.3333Z",
    stroke: "#7747E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_980_1144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.c16e39692349e2d6afbdf8636c3e454d.svg";
export { ForwardRef as ReactComponent };